import { render, staticRenderFns } from "./TabsLayout.vue?vue&type=template&id=4f0eb632&"
import script from "./TabsLayout.vue?vue&type=script&lang=js&"
export * from "./TabsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports